import { render, staticRenderFns } from "./SelectStakeType.vue?vue&type=template&id=1e007759&scoped=true&"
import script from "./SelectStakeType.vue?vue&type=script&lang=js&"
export * from "./SelectStakeType.vue?vue&type=script&lang=js&"
import style0 from "./SelectStakeType.vue?vue&type=style&index=0&id=1e007759&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e007759",
  null
  
)

export default component.exports